import { render, staticRenderFns } from "./ManufacturerList.vue?vue&type=template&id=67dd6d9e&scoped=true"
import script from "./ManufacturerList.vue?vue&type=script&lang=js"
export * from "./ManufacturerList.vue?vue&type=script&lang=js"
import style0 from "./ManufacturerList.vue?vue&type=style&index=0&id=67dd6d9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dd6d9e",
  null
  
)

export default component.exports